<template>
  <div class="row pt-5 pb-4 px-5 mx-auto m-4 shadow w-100 border-radius">
    <div class="row justify-content-end w-100 mx-auto">
      <div class="col-4">
        <img class="img-fluid" src="/img/profileIcons/happy.png" alt="" />
      </div>
      <div class="col-4 p-0 my-auto">
        <p><i class="fas fa-arrow-up"></i> 30%</p>
      </div>
    </div>

    <div class="row mt-2 w-100 mx-auto">
      <h3 class="w-100 text-center">Feedback</h3>
    </div>

    <div class="row mt-2 w-100 mx-auto">
      <div class="col-5 text-center">
        <p><strong>Last week</strong></p>
      </div>
      <div class="col-2 text-center"><p>vs</p></div>
      <div class="col-5 text-center">
        <p><strong>This week</strong></p>
      </div>
    </div>

    <div class="row m-0 w-100 mx-auto border-between">

      <div class="col-6">
        <div class="row mr-2">
          <div class="col-10 p-0">
            <p><small>Downtime comments:</small></p>
          </div>
          <div class="col-2 p-0 text-right">
            <p><small>16</small></p>
          </div>
        </div>
        <div class="row mr-2">
          <div class="col-10 p-0">
            <p><small>Job comments:</small></p>
          </div>
          <div class="col-2 p-0 text-right">
            <p><small>14</small></p>
          </div>
        </div>
        <div class="row mr-2">
          <div class="col-10 p-0">
            <p><small>Total comments:</small></p>
          </div>
          <div class="col-2 p-0 text-right">
            <p><small>30</small></p>
          </div>
        </div>
      </div>

      <div class="col-6">
        <div class="row ml-2">
          <div class="col-10 p-0">
            <p><small>Downtime comments:</small></p>
          </div>
          <div class="col-2 p-0 text-right">
            <p><small>16</small></p>
          </div>
        </div>
        <div class="row ml-2">
          <div class="col-10 p-0">
            <p><small>Job comments:</small></p>
          </div>
          <div class="col-2 p-0 text-right">
            <p><small>14</small></p>
          </div>
        </div>
        <div class="row ml-2">
          <div class="col-10 p-0">
            <p><small>Total comments:</small></p>
          </div>
          <div class="col-2 p-0 text-right">
            <p><small>30</small></p>
          </div>
        </div>
      </div>

      

    </div>

    <div></div>
  </div>
</template>

<script>
export default {
  mixins: [],
  props: ["user"],
  components: {},

  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
@import "./src/assets/scss/components/engagement/_EmployeeProfile.scss";
</style>